import { render, staticRenderFns } from "./CollectionItemForm.vue?vue&type=template&id=4e680fc0&scoped=true&"
import script from "./CollectionItemForm.vue?vue&type=script&lang=js&"
export * from "./CollectionItemForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemForm.vue?vue&type=style&index=0&id=4e680fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e680fc0",
  null
  
)

export default component.exports